import getAxiosInstance from "../../common/mhiAxios";

export default {
    // SlideStockの資料ダウンロード
    getSlideStockDocument(id: number, fileName: string): Promise<any> {
        return getAxiosInstance()
            .post("/api/getDocMeterial", { id: id, fileName: fileName })
            .then(({ data }) => data)
            .catch((error) => {
                return error;
            });
    },

    // 動画の資料ダウンロード
    getVideoDocument(id: number, fileName: string): Promise<any> {
        return getAxiosInstance()
            .post("/api/getVideoMeterial", { id: id, fileName: fileName })
            .then(({ data }) => data)
            .catch((error) => {
                return error;
            });
    },
};
